<div class="card">
  <div class="card-body">
    <div class="row mt-4 mt-md-5 details">
      <div class="col-6">
        <p class="ml-3 details_1">Warranty Card</p>
      </div>
      <div class="col-6">
        <img
          src="../../../../../assets/img/ac.svg"
          alt=""
          class="img-fluid d-block ml-auto"
          style="width: 30px;"
        />
      </div>
    </div>

    <hr />
    <div class="row details">
      <div class="col-6">
        <p class="ml-3 details_1">Start date</p>
      </div>
      <div class="col-6 d-flex align-items-center justify-content-end">
        <p class="text-right details_2" *ngIf="appliance">
          {{ appliance.purchaseDate | date: "dd/MM/yyyy" }}
        </p>
        <p class="text-right details_2 font-weight-bold" *ngIf="appliance.purchaseDate == null">---</p>
      </div>
    </div>

    <hr />
    <div class="row details">
      <div class="col-6">
        <p class="ml-3 details_1">End Date</p>
      </div>
      <div class="col-6 d-flex align-items-center justify-content-end">
        <p class="text-right details_2" *ngIf="appliance">
          {{ appliance.warrantyEndDate | date: "dd/MM/yyyy" }}
        </p>
        <p class="text-right details_2 font-weight-bold" *ngIf="appliance.warrantyEndDate == null">---</p>
      </div>
    </div>

    <hr />
  </div>
</div>
